import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['modalDelete', 'modalResetPassword', 'modalResendConfirm']

  connect() {
    this.deleteUrl = null
    this.resetPasswordUrl = null
    this.resendConfirmUrl = null
    this.userId = null
  }

  openModal(event) {
    const { modalName, deleteUrl, resetPasswordUrl, resendConfirmUrl, userId } = event.params
    this.userId = userId
    switch (modalName) {
      case 'modalDelete':
        this.deleteUrl = deleteUrl
        this.modalDeleteTarget.setAttribute("style", "display: block;")
        break
      case 'modalResetPassword':
        this.resetPasswordUrl = resetPasswordUrl
        this.modalResetPasswordTarget.setAttribute("style", "display: block;")
        break
      case 'modalResendConfirm':
        this.resendConfirmUrl = resendConfirmUrl
        this.modalResendConfirmTarget.setAttribute("style", "display: block;")
    }
  }

  closeModal() {
    this.deleteUrl = null
    this.resetPasswordUrl = null
    this.resendConfirmUrl = null
    this.userId = null
    this.modalDeleteTarget.setAttribute("style", "display: none;")
    this.modalResetPasswordTarget.setAttribute("style", "display: none;")
    this.modalResendConfirmTarget.setAttribute("style", "display: none;")
  }

  deleteCorporationUser() {
    Rails.ajax({
      url: this.deleteUrl,
      type: "DELETE",
      success: (response) => {
        if (response.success) {
          location.reload()
        }
      }
    })
  }

  sendResetPassword() {
    document.querySelector(`#reset_${this.userId}`).setAttribute("disabled", "disabled")
    Rails.ajax({
      url: this.resetPasswordUrl,
      type: "GET",
      success: (response) => {
        if (response.success) {}
      }
    })
    this.closeModal()
  }
  
  resendConfirm() {
    document.querySelector(`#confirm_${this.userId}`).setAttribute("disabled", "disabled")
    Rails.ajax({
      url: this.resendConfirmUrl,
      type: "GET",
      success: (response) => {
        if (response.success) {}
      }
    })
    this.closeModal()
  }
}
